// 微信登录配置
export const WECHAT_CONFIG = {
  // 微信开放平台AppID
  APP_ID: process.env.REACT_APP_WECHAT_APP_ID || 'wx0c75a731845b4367',
  
  // 微信授权回调地址
  REDIRECT_URI: process.env.REACT_APP_WECHAT_REDIRECT_URI || `${window.location.origin}/wechat-callback`,
  
  // 授权作用域 - 网页应用内使用
  SCOPE: 'snsapi_userinfo',
  
  // 扫码登录作用域 - 开放平台使用
  QRCODE_SCOPE: 'snsapi_login',
  
  // 状态参数
  STATE: 'wechat_login',
  
  // 微信授权URL - 网页应用内使用
  AUTH_URL: 'https://open.weixin.qq.com/connect/oauth2/authorize',
  
  // 微信扫码登录URL - 开放平台使用
  QRCODE_AUTH_URL: 'https://open.weixin.qq.com/connect/qrconnect',
  
  // 微信JS-SDK URL
  JS_SDK_URL: 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js',
} as const;

// 微信浏览器检测
export const isWechatBrowser = (): boolean => {
  return /MicroMessenger/i.test(navigator.userAgent);
};

// 生成微信授权URL - 网页应用内使用
export const generateWechatAuthUrl = (): string => {
  const { APP_ID, REDIRECT_URI, SCOPE, STATE, AUTH_URL } = WECHAT_CONFIG;
  
  const params = new URLSearchParams({
    appid: APP_ID,
    redirect_uri: REDIRECT_URI,
    response_type: 'code',
    scope: SCOPE,
    state: STATE,
  });
  
  return `${AUTH_URL}?${params.toString()}#wechat_redirect`;
};

// 生成微信扫码登录URL - 开放平台使用
export const generateWechatQRCodeAuthUrl = (): string => {
  const { APP_ID, REDIRECT_URI, QRCODE_SCOPE, STATE, QRCODE_AUTH_URL } = WECHAT_CONFIG;
  
  const params = new URLSearchParams({
    appid: APP_ID,
    redirect_uri: REDIRECT_URI,
    response_type: 'code',
    scope: QRCODE_SCOPE,
    state: STATE,
  });
  
  return `${QRCODE_AUTH_URL}?${params.toString()}#wechat_redirect`;
};

// 微信JS-SDK配置
export const WECHAT_JS_SDK_CONFIG = {
  debug: process.env.NODE_ENV === 'development',
  appId: WECHAT_CONFIG.APP_ID,
  timestamp: '',
  nonceStr: '',
  signature: '',
  jsApiList: ['login', 'getUserInfo'],
} as const; 